<template>
  <div id="app" class>
    <nav
      class="py-1 navbar font-weight-bold d-flex fixed-top navbar-info bg-info"
    >
      <b-navbar-brand class="text-white brandHeight" href="#" id="returnhome">
        <font-awesome-icon
          class="align-top mr-2"
          :icon="['fas', 'mask']"
          size="lg"
        />
        <span class="align-top d-inline-block">Sowlution</span>
        <div
          :class="{
            hide: show === false,
            'align-top d-inline-block ml-2': show === null || show,
          }"
        >
          <div class="spinner-border text-white" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </b-navbar-brand>
      <div v-if="$store.getters.isAuthenticated" class="float-right mr-1">
        <!-- <font-awesome-icon class="text-white mr-3" :icon="['fas', 'th-list']" size="lg" /> -->
        <b-dropdown id="ddown1" class="m-md-2 active" ref="dropdownRef">
          <template v-slot:button-content>
            <font-awesome-icon
              class="text-white mr-1"
              :icon="['fas', 'user']"
              size="lg"
            />
            {{ $store.getters.user.name }}
          </template>
          <b-dropdown-item>
            <font-awesome-icon
              class="text-info mr-2"
              :icon="['fas', 'th-list']"
              size="lg"
            />
            <router-link to="/sows" class="text-info">View SoWs</router-link>
          </b-dropdown-item>
          <!-- <b-dropdown-item>
            <font-awesome-icon class="text-info mr-2" :icon="['fas', 'th-list']" size="lg" />
            <router-link to="/baas" class="text-info">View BAAs</router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <font-awesome-icon class="text-info mr-2" :icon="['fas', 'th-list']" size="lg" />
            <router-link to="/ndas" class="text-info">View NDAs</router-link>
          </b-dropdown-item>-->
          <b-dropdown-item>
            <font-awesome-icon
              class="text-info mr-2"
              :icon="['fas', 'th-list']"
              size="lg"
            />
            <router-link to="/baandas" class="text-info"
              >View BAA & NDAs</router-link
            >
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="$store.getters.uaa.logout()">
            <font-awesome-icon
              class="text-info mr-2"
              :icon="['fas', 'sign-out-alt']"
              size="lg"
            />
            <span class="text-info"
              >Signout</span
            >
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </nav>
    <div class="py-2 container-fluid" style="margin-top: 60px">
      <div v-if="isStage" class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="page-header d-flex justify-content-center text-info">
              <h4 v-if="!this.$store.getters.amendmentMode">
                {{ stages.length }} Simple Steps To Generate SoW
              </h4>
              <h4 v-if="this.$store.getters.amendmentMode">
                {{ stages.length }} Simple Steps To Generate
                {{
                  this.$store.getters.selectedIncidentType == "it-mdr"
                    ? "Renewal Contract"
                    : "SoW Amendment"
                }}
              </h4>
            </div>
            <div
              class="d-flex justify-content-center"
              style="
                height: 110px;
                display: inline-block;
                width: 100%;
                overflow-y: auto;
              "
            >
              <ul
                class="
                  w-100
                  d-flex
                  justify-content-center
                  timeline timeline-horizontal
                "
              >
                <li
                  class="timeline-item d-flex justify-content-center"
                  v-for="stage in stages"
                  v-bind:key="stage.id"
                >
                  <div
                    class="timeline-badge"
                    v-bind:class="{
                      primary: stage.Status === 'Current',
                      success: stage.Status === 'Done',
                    }"
                  ></div>
                  <div class="p-2" style="position: absolute; top: 50px">
                    <!-- 
                        <i class="glyphicon glyphicon-check"></i>
                        <div class="timeline-heading">
                          <h4 class="timeline-title">{{stage.Title}}</h4>
                          <p><small class="text-muted"><i class="glyphicon glyphicon-time"></i> 11 hours ago via Twitter</small></p>
                        </div> 
                    -->
                    <div class>
                      <p>{{ stage.Title }}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="toasts">
        <b-toast title="msg.title" static :key="msg.title" v-for="msg in getToasts">
            {{msg.message}}
        </b-toast>
      </div>-->
      <router-view v-bind:showForm="!show" />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import security from "./utils/msalUtil";
export default {
  created() {
    this.state = true;
    if (this.$route.name === "home") {
      this.isStage = false;
    }
  },
  mounted() {
    let that = this;
    that.show = false;
    this.$root.$on("progress", function () {
      that.show = true;
    });
    this.$root.$on("init", function () {
      that.$store.commit("init");
      for (let index = 0; index < that.stages.length; index++) {
        const element = that.stages[index];
        element.Status = "NotStarted";
      }
    });
    this.$root.$on("b-dropdown-item-button::click", (bvEvent) => {
      console.log("entered");
    }),
      this.$root.$on("done", function () {
        that.show = false;
      });
    this.$root.$on("removestage", function () {
      that.isStage = false;
    });
    this.$root.$on("toast", function (msg) {
      that.$bvToast.toast(msg.message, {
        title: msg.title,
        autoHideDelay: 3000,
        appendToast: true,
        solid: true,
      });
    });
    this.$root.$on("stage", function (params) {
      that.isStage = true;
      let stageIndex = params;
      stageIndex = stageIndex - 1;
      if (stageIndex <= that.stages.length - 1) {
        that.stages[stageIndex].Status = "Current";
      }
      for (let index = 0; index < stageIndex; index++) {
        that.stages[index].Status = "Done";
      }
    });
    this.$root.$on("nostage", function (params) {
      that.isStage = false;
    });
    const el = document.getElementById("returnhome");
    el.addEventListener(
      "click",
      function () {
        that.$store.commit("init");
        if (window.location.pathname != "/choose-document") {
          that.$router.push({
            path: "/choose-document",
          });
        }
      },
      false
    );
  },
  computed: {
    getToasts() {
      return _.filter(this.msgs, (msg) => !msg.hide);
    },
  },
  methods: {
    user() {
      this.$store.getters.user.name;
    },
    getStageClass(status) {
      switch (status) {
        case "Current":
          return " primary";
          break;
        case "Done":
          return "timeline-badge success";
          break;
        case "NotStarted":
        default:
          return "timeline-badge";
          break;
      }
    },
  },
  data() {
    return {
      show: true,
      isStage: false,
      IsamendmentMode: this.$store.getters.amendmentMode,
      stages: [
        {
          Title: "Choose SoW Template",
          Id: "1",
          Status: "NotStarted", //NotStarted, Current, Done,
        },
        {
          Title: "Fill Template Placeholders",
          Id: "2",
          Status: "NotStarted",
        },
        {
          Title: "Set Scope Values",
          Id: "3",
          Status: "NotStarted",
        },
        {
          Title: "Review SoW Content",
          Id: "3",
          Status: "NotStarted",
        },
      ],
      msgs: [],
    };
  },
  methods: {
    showProgress: function () {},
    hideProgress: function () {},
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.card {
  width: 70%;
}
label {
  color: #17a2b8;
}
.b-toaster-slot {
  top: 70px !important;
}
.hide {
  display: none;
}
svg {
  cursor: pointer;
}
.navbar {
  height: 62px;
}
.brandHeight {
  height: 36px;
}
.serviceCard .card-header {
  background-color: white !important;
}
.nav-tabs .nav-link {
  border-bottom: 1px solid lightgray !important;
  border: 1px white !important;
  color: black !important;
}
.nav-link.active {
  border-bottom: 2px solid #17a2b8 !important;
  color: #17a2b8 !important;
  transform: scale(1);
}
.nav-link:hover {
  border-bottom: 2px solid #17a2b8 !important;
  color: #17a2b8 !important;
  transform: scale(1);
}
.nav-tabs .nav-link.disabled {
  color: gray !important;
}
.badge-light {
  cursor: pointer;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: transparent !important;
}
.vdp-datepicker * {
  display: block;
  width: 100%;
}
#msadate,
#sowdate,
#effectivedate {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem;
}
#msadate:focus,
#sowdate:focus,
#effectivedate:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.recordsdiv {
  min-height: 600px !important;
}
.error {
  color: red;
  border-color: #fdd;
}
.actionswidth {
  width: 10%;
}
.actionswidth > div {
  justify-content: center;
}
.thcust {
  background: #17a2b8;
  color: WHITE;
}
</style>
